import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import {getToken,getBaseUrl} from '@/utils/store'
import config from '@/utils/config'
//import { Loading } from 'element-ui';
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css'


let baseURL = config.baseURL;
let clientVer = config.version;


function startLoading() {    //使用Element loading-start 方法
  NProgress.start()
}

function endLoading() {
  NProgress.done() // 设置加载进度条(结束..)
}

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


// create an axios instance
const service = axios.create({
  baseURL: getBaseUrl() || baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    let token = getToken()

    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      //config.headers.common['Token'] = token;
      config.headers['MT-Token'] = token;
    }
    config.headers['Accept'] = "application/json";
    config.headers['Content-Type'] = "application/json;charset=UTF-8";
    showFullScreenLoading()
    return config
  },
  error => {
    // do something with request error
    tryHideFullScreenLoading()
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    //console.log(res)
    tryHideFullScreenLoading()
    // if the custom code is not 20000, it is judged as an error.
    if (res.code != 2000) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 3 * 1000
      });
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res.data ? res.data : res
    }
  },
  error => {
    tryHideFullScreenLoading()
    console.log('err' + error) // for debug
    Message({
      message: error.msg || "请求失败",
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js